import { render } from "./GraphQL-Layout.vue?vue&type=template&id=5f6812f7"
import script from "./GraphQL-Layout.vue?vue&type=script&lang=js"
export * from "./GraphQL-Layout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__